export default __webpack_public_path__ + "static/media/SIFA_FR_EPILOGUE04.5c4fc707.mp3";